'use client'

import OrderCard from "./OrderCard"
import Pagination from "@/components/elements/Pagination"
import Skeleton from "@/components/elements/Skeleton"
import EmptyState from "../elements/EmptyState"
import { ReceiptText } from "lucide-react"

export default function OrderList({ orderList }: { orderList: any }) {
  if (orderList === undefined) return <OrderListSkeleton />

  const orders = orderList || []

  return (
    <div>
      <div className="flex items-end justify-between gap-4 pb-6 border-b border-border">
        <div className="min-w-0">
          <h1 className="text-2xl sm:text-3xl tracking-tight text-foreground">Захиалгууд</h1>
          <p className="mt-2 text-sm text-muted-foreground">Таны хийсэн хамгийн сүүлийн захиалгууд</p>
        </div>
        {orders.length > 0 && <span className="shrink-0 text-[13px] text-muted-foreground tabular-nums">{orders.length} захиалга</span>}
      </div>
      <Pagination items={orders} component={({ item }: { item: any }) => <OrderCard order={item} />} limit={10} empty={OrderNotFound} showSearch={false} searchFields={[]} containerClassName="grid-cols-1! sm:grid-cols-1! md:grid-cols-1! gap-0! divide-y divide-border border-b border-border" />
    </div>
  )
}

export function OrderNotFound() {
  return <EmptyState icon={ReceiptText} title="Захиалга байхгүй байна" description="Таны хийсэн захиалгууд энд харагдах болно." />
}

function OrderListSkeleton() {
  return (
    <div>
      <div className="pb-6 border-b border-border space-y-2">
        <Skeleton className="w-40 h-8 rounded-none" />
        <Skeleton className="w-64 max-w-full h-4 rounded-none" />
      </div>
      <div className="divide-y divide-border">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex items-center gap-6 py-6">
            <Skeleton className="w-12 aspect-3/4 rounded-none" />
            <div className="flex-1 space-y-2">
              <Skeleton className="w-40 h-4 rounded-none" />
              <Skeleton className="w-28 h-3 rounded-none" />
            </div>
            <Skeleton className="w-20 h-4 rounded-none" />
          </div>
        ))}
      </div>
    </div>
  )
}
